import { JsonFileUpload } from '@/common/components/JsonFileUpload.tsx';
import { MacroTermSheetParam } from '@/pages/document-autofill/term-sheets/macro-term-sheet.tsx';
import { useCallback } from 'react';
import { FormInstance } from 'antd';

export const MacroTermSheetImport = ({form}: { form: FormInstance<MacroTermSheetParam>}) => {
  const { setFieldsValue } = form

  const onFileImport = useCallback((data: MacroTermSheetParam) => {
    setFieldsValue({
      personalInfo: data.personalInfo,
      employmentDetails: data.employmentDetails,
      financialTerms: data.financialTerms,
      deferredProgram: data.deferredProgram,
      teamHiring: data.teamHiring,
      riskParameters: data.riskParameters
    })
  }, [setFieldsValue])

  return (
    <>
      <JsonFileUpload label="Import Macro Term Sheet" updateFormWithJson={onFileImport}/>
    </>
  )
}